module.exports = __webpack_public_path__ + "img/official_accounts_bg@2x.2ae8fd2a.png";